import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class RemindTechnicianService {
  alertOptions = signal([]);

  constructor(private translateService: TranslateService) {}

  setAlertOptions() {
    this.alertOptions.set(this.getTranslatedAlertOptions());
  }

  getTranslatedAlertOptions() {
    return ALERT_OPTIONS.map((option) => ({
      ...option,
      displayName: this.translateService.instant(option.translateKey),
    }));
  }
}

export const ALERT_OPTIONS = [
  {
    value: 0,
    subItem: null,
    translateKey: 'technicianNotification.notificationOption.workOrderStart',
  },
  {
    value: 5,
    subItem: null,
    translateKey: 'technicianNotification.notificationOption.fiveMinutesBefore',
  },
  {
    value: 15,
    subItem: null,
    translateKey:
      'technicianNotification.notificationOption.fifteenMinutesBefore',
  },
  {
    value: 30,
    subItem: null,
    translateKey:
      'technicianNotification.notificationOption.thirtyMinutesBefore',
  },
  {
    value: 60,
    subItem: null,
    translateKey: 'technicianNotification.notificationOption.oneHourBefore',
  },
  {
    value: 120,
    subItem: null,
    translateKey: 'technicianNotification.notificationOption.twoHoursBefore',
  },
  {
    value: 240,
    subItem: null,
    translateKey: 'technicianNotification.notificationOption.fourHoursBefore',
  },
  {
    value: 1440,
    subItem: null,
    translateKey: 'technicianNotification.notificationOption.oneDayBefore',
  },
  {
    value: 10080,
    subItem: null,
    translateKey: 'technicianNotification.notificationOption.oneWeekBefore',
  },
];
